import { render } from "./CommentThread.vue.js?vue&type=template&id=1a618de8&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentThread.vue?vue&type=template&id=1a618de8&scoped=true"
import script from "./CommentThread.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentThread.vue?vue&type=script&lang=js"
export * from "./CommentThread.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentThread.vue?vue&type=script&lang=js"

import "./CommentThread.vue.scss?vue&type=style&index=0&id=1a618de8&scoped=true&lang=scss!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentThread.vue?vue&type=style&index=0&id=1a618de8&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a618de8"],['__file',"src/SharedWeb/scripts/components/community/chatrooms/comments/CommentThread.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a618de8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a618de8', __exports__)) {
    api.reload('1a618de8', __exports__)
  }
  
  module.hot.accept("./CommentThread.vue.js?vue&type=template&id=1a618de8&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommentThread.vue?vue&type=template&id=1a618de8&scoped=true", () => {
    api.rerender('1a618de8', render)
  })

}


export default __exports__